import { gql } from '@apollo/client';

type EmployeeStatus = 'not_requested' | 'in_progress' | 'applying' | 'rejected' | 'accepted' | 'not_need_adj' | 'fixed';
type ResidentsTaxCollectionMethod = 'from_salary' | 'normally_for_resign' | 'normally_others';

export type QueryResult = {
  request: Request;
  clientSetting: ClientSetting;
};

export type Request = {
  id: string;
  comment?: string;
  requestComments: RequestComment[];
  employee: Employee;
  actedUser: User;
  updatedAt: string;
};

type RequestComment = {
  id: string;
  actedUser: User;
  commentBy: string;
  comment: string;
  createdAt: string;
};

type ResignType = 'others' | 'passed_away' | 'disability';

type TaxSchedule = 'first' | 'second';

export type Employee = {
  id: number;
  email: string;
  staffCode: string;
  status: EmployeeStatus;
  joinedOn: string;
  resignedOn: string;
  resignType: ResignType;
  employmentType: string;
  position: string;
  isNonResident: boolean;
  profile: Profile;
  request?: Request;
  taxSchedule: TaxSchedule;
  residentsTaxCollectionMethod: ResidentsTaxCollectionMethod;
  hasNoPayment: boolean;
  salaryGreaterThan20Million: boolean;
};

type Profile = {
  id: string;
  firstName: string;
  lastName: string;
};

type User = {
  id: string;
  name: string;
};

export type ClientSetting = {
  id: string;
  submissionDeadline: SubmissionDeadline;
};

type SubmissionDeadline = {
  id: string;
  submissionDeadlineAt: string;
};

export const FETCH_EMPLOYEE_INPUT = gql`
  query fetchRequest {
    request {
      id
      comment
      requestComments {
        id
        actedUser {
          id
          name
        }
        commentBy
        comment
        createdAt
      }
      employee {
        id
        status
        profile {
          id
          firstName
          lastName
        }
      }
      actedUser {
        id
        name
      }
      updatedAt
    }
    clientSetting {
      id
      submissionDeadline {
        id
        submissionDeadlineAt
      }
    }
  }
`;
